import { Skeleton } from "@mui/material"
import React from "react"
// 💨 Skeleton placeholder
export const ContactSkeleton = ({ multiplos = false }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      padding: "16px 24px 16px 24px",
      width: "100%",
      justifyContent: "space-between",
    }}
  >
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <Skeleton variant="circular" width={40} height={40} />
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        <Skeleton variant="text" width={120} height={18} />
        <Skeleton variant="text" width={80} height={14} />
      </div>
    </div>
    {multiplos ? (
      <Skeleton variant="rectangular" width={22} height={22} style={{ borderRadius: 4 }} />
    ) : (
      <Skeleton variant="circular" width={24} height={24} style={{ borderRadius: "100%" }} />
    )}
  </div>
)
